/**
 * API client for the per-institution course aliases / cross-listings browser
 * (admin backend, Phase 4). Institution scoping via the X-Institution-Id header.
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

export async function fetchAliases({ source, search, page, perPage } = {}) {
  const p = new URLSearchParams();
  if (source) p.set('source', source);
  if (search) p.set('search', search);
  if (page) p.set('page', page);
  if (perPage) p.set('per_page', perPage);
  const res = await fetch(`${API_URL}/api/aliases?${p.toString()}`);
  if (!res.ok) throw new Error(`Failed to fetch aliases: ${res.status}`);
  return res.json();
}
